<template>
    <div>
        <CCol sm="12">
            <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left" @click="GoToSettingProfile()"/>
            <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
        </CCol>
        <CCol sm="12">
            
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Employment Detail</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Employee No</h3>
                                        <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Company</h3>
                                        <CInput type="text" v-model="detailStaff.FullName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Position</h3>
                                        <CInput type="text" v-model="detailStaff.PositionName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Branch Location</h3>
                                        <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date Joining</h3>
                                        <CInput type="date" v-model="detailStaff.DateJoinCompany" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Date of Sign (Lo)</h3>
                                        <CInput type="date" v-model="detailStaff.ShortName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Employee Type</h3>
                                        <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Department</h3>
                                        <CInput type="text" v-model="detailStaff.DepartmentName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Employee Status</h3>
                                        <CInput type="text" v-model="detailStaff.FullNames" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">OKU Status</h3>
                                        <CInput type="text" v-model="detailStaff.FullNames" disabled/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
    
                    </div>
                </div>
    
                </CCard>
                <!-- <CCard class="p-3 custom-border-radius-16px mt-2" style="border:none">
                    <CCol sm="12" md="4" lg="3" class="text-left p-2" v-for="button in buttons" :key="button.value">
                            <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                                <img :src="activeButton === button.value ? require(`@/assets/img/${button.activeIcon}`) : require(`@/assets/img/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                            </div>
                        </CCol>
                        <CCard class="p-3 custom-border-radius-16px mt-2" style="border:none">
                            <CCol>
                            <div v-if="activeButton === 'Approval'">
                            <div>
                        <div class="p-2">
                            <CRow>
                                <CCol sm="10">
                                    <h3 class="custom-18px-500 font-color-171717">Approval Details</h3>
                                </CCol>
                                <CCol sm="2">
                                    <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">First Approval</h3>
                                            <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                        </CCol>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">Second Approval</h3>
                                            <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
        
                        </div>
                    </div>
                            </div>
                            <div v-if="activeButton === 'ClaimSupervisor'">
                            <div>
                        <div class="p-2">
                            <CRow>
                                <CCol sm="10">
                                    <h3 class="custom-18px-500 font-color-171717">Approval Details</h3>
                                </CCol>
                                <CCol sm="2">
                                    <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">First Approval</h3>
                                            <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                        </CCol>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">Second Approval</h3>
                                            <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
        
                        </div>
                    </div>
                            </div>
                            <div v-if="activeButton === 'OvertimeSupervisor'">
                            <div>
                        <div class="p-2">
                            <CRow>
                                <CCol sm="10">
                                    <h3 class="custom-18px-500 font-color-171717">Approval Details</h3>
                                </CCol>
                                <CCol sm="2">
                                    <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">First Approval</h3>
                                            <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                        </CCol>
                                        <CCol sm="6">
                                            <h3 class="custom-14px-500 font-color-171717">Second Approval</h3>
                                            <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
        
                        </div>
                    </div>
                            </div>
                            <div v-if="activeButton === 'TimeOffSupervisor'">
                            <div>
                            <div class="p-2">
                                <CRow>
                                    <CCol sm="10">
                                        <h3 class="custom-18px-500 font-color-171717">Approval Details</h3>
                                    </CCol>
                                    <CCol sm="2">
                                        <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol sm="12">
                                        <CRow>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">First Approval</h3>
                                                <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                            </CCol>
                                            <CCol sm="6">
                                                <h3 class="custom-14px-500 font-color-171717">Second Approval</h3>
                                                <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>
            
                            </div>
                            </div>
                            </div>
                        </CCol>
                        </CCard>
                    </CCard> -->
                <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div>
                    <div class="p-2">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-500 font-color-171717">Approval Details</h3>
                            </CCol>
                            <CCol sm="2">
                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">First Approval</h3>
                                        <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px-500 font-color-171717">Second Approval</h3>
                                        <CInput type="text" v-model="detailStaff.RegistrationNumber" disabled/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
    
                    </div>
                </div>
                </CCard>
                <CCol sm="12">
                    <CRow>
                        <CCol sm="6">
                            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                <div>
                                    <div class="p-2">
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-18px-500 font-color-171717">Yearly Form</h3>
                                            </CCol>
                                            <CCol sm="2">
                                                <img src="../assets/img/edit-linear.png" style="max-width:18px;" class="float-right"/>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="12">
                                                <CRow>
                                                    <CCol sm="6">
                                                        <h3 class="custom-14px-500 font-color-171717">EA Person In Charge</h3>
                                                        <CInput type="text" v-model="detailStaff.ShortName" disabled/>
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                        </CRow>
                    
                                    </div>
                                </div>
            
                            </CCard>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                                <div>
                                    <div class="p-2">
                                        <CRow>
                                            <CCol sm="10">
                                                <h3 class="custom-18px-500 font-color-171717">Company Access</h3>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol sm="12">
                                                <CRow>
                                                    <CCol sm="6">
                                                        <h3 class="custom-14px-500 font-color-171717">Advanced Cellnet Sdn Bhd <CSwitch class="ml-3" size="sm" shape="pill" color="primary" data-on="On" data-off="Off" checked/></h3>
                                                        <label type="text"></label>
                                                    </CCol>
                                                </CRow>
                                            </CCol>
                                        </CRow>
                    
                                    </div>
                                </div>
            
                            </CCard>
                        </CCol>
                    </CRow>
                    
                    
                </CCol>
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            user: {},
            detailStaff: {},
            activeButton: 'Approval',
            buttons: [
                { value: 'Approval', label: 'Approval', activeIcon: 'checked-white.png', inactiveIcon: 'checked-blue.png' },
                { value: 'ClaimSupervisor', label: 'Claim Supervisor', activeIcon: 'clocked-white.png', inactiveIcon: 'clock-blue.png' },
                { value: 'OvertimeSupervisor', label: 'Overtime Supervisor', activeIcon: 'summary-white.png', inactiveIcon: 'summary-blue.png' },
                { value: 'TimeOffSupervisor', label: 'Time-Off Supervisor', activeIcon: 'summary-white.png', inactiveIcon: 'summary-blue.png' },
            ],

        }





    },
    async mounted() {
        await this.GetListDetailStaff();
        await this.GetInfoUser();

    },

    computed: {

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + this.$route.query.id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },
        async GoToSettingProfile(pageName = "SettingProfile") {
            let id = this.$route.query.id; // Retrieve the `id` from the current route

            if (!id) {
                console.warn("ID is missing in the query parameters!");

                // Fetch the user ID using GetInfoUser method
                try {
                    await this.GetInfoUser(); // Call GetInfoUser to populate `this.user`
                    id = this.user?.id; // Assume `this.user` contains `id` after fetching

                    if (!id) {
                        console.error("Unable to retrieve user ID from user information.");
                        alert("An error occurred. Please log in again.");
                        return this.$router.push({ path: "/Login" }); // Redirect to login if ID is missing
                    }
                } catch (error) {
                    console.error("Error retrieving user ID:", error);
                    alert("An error occurred. Please log in again.");
                    return this.$router.push({ path: "/Login" });
                }
            }

            // Navigate to the specified page with the resolved `id` as query parameter
            this.$router.push({ name: pageName, query: { id } });
        },
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },


    }

};
</script>